/**@example */
const getFormattedDayBeforeYesterdayDate = () => {
  const dayBeforeYesterday = new Date();
  dayBeforeYesterday.setDate(dayBeforeYesterday.getDate() - 1);
  return dayBeforeYesterday.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  });
};

/**@example */
const getFormattedDate = () => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate());
  return yesterday.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  });
};

export const wemSessionsTabData = [
  {
    id: '0',
    focusArea: 'Average Handling Time',
    metric: '',
    coachingType: 'Coach the Coach',
    coachName: 'Administrator01 Perm_TestGBU',
    coachingDate: getFormattedDayBeforeYesterdayDate(),
    lastUpdated: getFormattedDate(),
    status: 'Overdue',
    schedule: '',
    acknowledgmentDueDate: getFormattedDayBeforeYesterdayDate(),
  },
  {
    id: '1',
    focusArea: 'CSAT',
    metric: '',
    coachingType: 'Group',
    coachName: 'Administrator01 Perm_TestGBU',
    coachingDate: getFormattedDayBeforeYesterdayDate(),
    lastUpdated: getFormattedDate(),
    status: 'Completed',
    schedule: '',
    acknowledgmentDueDate: getFormattedDayBeforeYesterdayDate(),
  },
  {
    id: '2',
    focusArea: 'Soft Skill',
    metric: '',
    coachingType: '1:1',
    coachName: 'Administrator01 Perm_TestGBU',
    coachingDate: getFormattedDayBeforeYesterdayDate(),
    lastUpdated: getFormattedDate(),
    status: 'Scheduled',
    schedule: '',
    acknowledgmentDueDate: getFormattedDayBeforeYesterdayDate(),
  },
];
